import { render } from "./BasicMap.vue?vue&type=template&id=7e1e2850"
import script from "./BasicMap.vue?vue&type=script&lang=js"
export * from "./BasicMap.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__